import { render, staticRenderFns } from "./widgetCustomerPostcodeCount.vue?vue&type=template&id=6913e6aa&"
import script from "./widgetCustomerPostcodeCount.vue?vue&type=script&lang=js&"
export * from "./widgetCustomerPostcodeCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports